<template>
  <div class="bg-div">
    <img
      class="bg-img"
      src="@/assets/images/home-example-bg.png"
    >
    <p class="b-col-p"> {{ $tc('message.example.title') }} </p>
    <b-row>
      <b-col
        md="4"
        offset-md="2"
        class="bg-agile"
      >
        <!-- <button class="b-col-btn-left" @click="$refs.carousel.goToPrev()">⬅️</button> -->
        <img
          class="b-col-btn-left"
          @click="$refs.carousel.goToPrev()"
          src="@/assets/images/home-example-left.png"
        >
        <agile
          ref="carousel"
          class="agile-slide"
          :dots="false"
          :navButtons="false"
          :autoplay="true"
          :infinite="true"
          :autoplay-speed="5000"
        >
          <div class="slide">
            <img
              class="slide-img"
              src="@/assets/images/home-example-logo.png"
            >
            <div class="slide-title-p">益狐智造科技（武汉）有限公司</div>
            <div class="slide-desc-p">汽车制造企业</div>
            <div class="slide-info-p">使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了</div>
          </div>
          <div class="slide">
            <img
              class="slide-img"
              src="@/assets/images/home-example-logo.png"
            >
            <div class="slide-title-p">益狐智造科技（北京）有限公司</div>
            <div class="slide-desc-p">火车制造企业</div>
            <div class="slide-info-p">使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了</div>
          </div>
          <div class="slide">
            <img
              class="slide-img"
              src="@/assets/images/home-example-logo.png"
            >
            <div class="slide-title-p">益狐智造科技（美国）有限公司</div>
            <div class="slide-desc-p">美国制造企业</div>
            <div class="slide-info-p">使用我们的APP十个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了使用我们的APP三个月，解决了</div>
          </div>
        </agile>
        <!-- <button class="b-col-btn-right" @click="$refs.carousel.goToNext()">➡️</button> -->
        <img
          class="b-col-btn-right"
          @click="$refs.carousel.goToNext()"
          src="@/assets/images/home-example-right.png"
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HomeContentExample",
};
</script>

<style lang="stylus" scoped>
.bg-div {
  position: relative;
}

.bg-img {
  width: 100%;
}

.bg-agile {
  position: absolute;
  bottom: 5rem;
  height: 12rem;

  .agile-slide {
    height: 12rem;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 0.6rem;
    padding-right: 1rem;

    .slide {
      padding-right: 1rem;

      .slide-img {
        padding-left: 0.5rem;
        padding-top: 1rem;
        height: 4rem;
      }

      .slide-title-p {
        font-size: 0.8rem;
        line-height: 0.9rem;
        margin-left: 5.5rem;
        margin-top: -2.5rem;
        margin-right: 1rem;
        color: #ffffff;
      }

      .slide-desc-p {
        padding-left: 5.5rem;
        padding-top: 0.5rem;
        padding-right: 1rem;
        font-size: 0.6rem;
        color: #cccccc;
      }

      .slide-info-p {
        font-size: 0.8rem;
        line-height: 0.9rem;
        padding-left: 5.5rem;
        padding-top: 0.5rem;
        padding-right: 1rem;
        color: #f1f1f1;
      }
    }
  }
}

.b-col-btn-left {
  position: absolute;
  padding: 0.1rem 0.1rem;
  bottom: 45%;
  left: -1.5rem;
}

.b-col-btn-right {
  position: absolute;
  padding: 0.1rem 0.1rem;
  bottom: 45%;
  right: -1.5rem;
}

.b-col-p {
  position: absolute;
  top: 5rem;
  left: 18%;
  font-size: 1.5rem;
  color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentExample.vue